import { useState } from 'react';
import ImageSlider from './ImageSlider';
import Navbar from './Navbar';
import fabricImage from '../assets/FABRIC.png';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../assets/fonts/fonts.css';

const Header = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      className="mb-4 bg-customRed bg-cover bg-center flex flex-col w-full overflow-hidden relative"
      style={{
        backgroundImage: `url(${fabricImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '110vh',
      }}
      id="Header"
    >
      {/* Navbar at the top */}
      <div className="relative z-50 w-full">
        <Navbar
          showMobileMenu={showMobileMenu}
          setShowMobileMenu={setShowMobileMenu}
        />
      </div>

      {/* Main content */}
      <div className="relative z-10 container text-center mx-auto flex-grow flex flex-col justify-center items-center px-4 sm:px-8 md:px-20 lg:px-32 text-white mt-10">
        <h2
          className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[62px] font-semibold mt-20"
          style={{ fontFamily: 'HighlandGothicFLF' }}
        >
          Welcome to <br /> Kobithan Garments
        </h2>
        <p className="text-base sm:text-base md:text-lg lg:text-xl mt-3 text-gray-200 max-w-3xl">
          We provide expert stitching, high-quality embroidery, and on-time
          delivery for your fully customized garments.
        </p>

        <div className="hidden md:flex justify-center mt-0 mb-10">
          <button
            onClick={() => navigate('/products')}
            className="mt-4 group px-6 py-1 rounded-full border-none transition-all duration-500 flex items-center space-x-4 shadow-xl active:scale-95 cursor-pointer"
            style={{ backgroundColor: 'white', color: '#801001' }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#801001';
              e.currentTarget.style.color = 'white';
              const iconBox = e.currentTarget.querySelector('.icon-box');
              if (iconBox) {
                iconBox.style.backgroundColor = 'white';
                iconBox.style.color = '#801001';
              }
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.color = '#801001';
              const iconBox = e.currentTarget.querySelector('.icon-box');
              if (iconBox) {
                iconBox.style.backgroundColor = '#801001';
                iconBox.style.color = 'white';
              }
            }}
          >
            <span className="text-lg uppercase tracking-wider">New Collection </span>
            <span 
              className="m-1 icon-box p-0 rounded-full transition-all duration-500 shadow-sm flex items-center justify-center"
              style={{ 
                minWidth: '32px', 
                minHeight: '32px', 
                backgroundColor: '#801001', 
                color: 'white' 
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.8"
                  d="M5 12h14M12 5l7 7-7 7"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>

      {/* ImageSlider at bottom */}
      <div className="w-full z-0 mt-auto pb-8">
        <ImageSlider />
      </div>
    </div>
  );
};

export default Header;
